import classNames from 'classnames'
import type {SVGProps} from 'react'
import type {IconsSvg} from '../../../svgs.ts'

import spriteUrl from './icons.svg?url'
import styles from './icon.module.scss'

export type IconProps = SVGProps<SVGSVGElement> & { id: IconsSvg; size?: number; outline?: boolean }

export function Icon({id, className, size = 16, outline, ...props}: IconProps) {
    const iconClassName = classNames(styles.icon, {[styles.outline]: outline}, className)

    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            className={iconClassName}
            {...props}
        >
            <use href={`${spriteUrl}#${id}`}/>
        </svg>
    )
}
